import React, { useState, ReactNode } from 'react';
import { AcquireTokenFunction, AuthStateProps } from '@konecorp/ui-library';

import Context, { ContextState } from './index';

type ReactProps = {
  children: ReactNode;
};

export default ({ children }: ReactProps): JSX.Element => {
  const authData = {
    isAuthenticated: false,
  } as AuthStateProps;

  const [authState, updateAuthState] = useState<AuthStateProps>(authData);
  const [isLoading, updateIsLoading] = useState<boolean>(false);
  const [showError, setShowError] = useState<boolean>(false);
  const [showSuccess, setShowSuccess] = useState<boolean>(false);

  const [message, setMessage] = useState<string>('');
  const [acquireToken, updateAcquireToken] = useState<
    AcquireTokenFunction | undefined
  >();

  const state: ContextState = {
    authState,
    isLoading,
    acquireToken,
    updateAuthState,
    updateAcquireToken,
    updateIsLoading,
    message,
    setMessage,
    showError,
    setShowError,
    showSuccess,
    setShowSuccess,
  };

  return <Context.Provider value={state}>{children}</Context.Provider>;
};
